import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RecaptchaModule } from 'ng-recaptcha';
import { AppComponent } from './app.component';
import { NavbarComponent } from './navbar/navbar.component';
import { FooterComponent } from './footer/footer.component';
import { HomeComponent } from './home/home.component';
import { DonorComponent } from './donor/donor.component';
import { RunnerComponent } from './runner/runner.component';
import { ContactComponent } from './contact/contact.component';
import { ParticipantsComponent } from './participants/participants.component';
import { LogInComponent } from './log-in/log-in.component';
import { JoinUpComponent } from './join-up/join-up.component';
import { NoMerchantComponent } from './no-merchant/no-merchant.component';
import { AllRacesComponent } from './all-races/all-races.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { TermsConditionsComponent } from './terms-conditions/terms-conditions.component';
import { DynamicPagesComponent } from './dynamic-pages/dynamic-pages.component';
import { LoaderComponent } from './loader/loader.component';
import { FindParticipantsPipe } from './pipe/find-participants.pipe';
import { WithoutDecimalsPipe } from './pipe/without-decimals.pipe';
import { LoginModalComponent } from './login-modal/login-modal.component';
import { CollectorUpdateComponent } from './collector-update/collector-update.component';
import { LoginService } from './services/login.service';

import { RouterModule, Routes } from '@angular/router';
import { StatusPageComponent } from './status-page/status-page.component';

const appRoutes: Routes = [
  { path: '', component: NoMerchantComponent },
  { path: ':merchant', component: AllRacesComponent },
  { path: ':merchant/:race_name', component: HomeComponent },
  { path: ':merchant/:race_name/participants', component: ParticipantsComponent },
  { path: ':merchant/:race_name/pages/contact', component: ContactComponent },
  { path: ':merchant/:race_name/pages/log-in', component: LogInComponent },
  { path: ':merchant/:race_name/pages/join-up', component: JoinUpComponent },
  { path: ':merchant/:race_name/update/:user_name', component: JoinUpComponent },
  { path: ':merchant/:race_name/dynamic/:page', component: DynamicPagesComponent },
  { path: ':merchant/:race_name/status/:status/msg/:msg', component: StatusPageComponent },
  { path: ':merchant/:race_name/:team_id', component: DonorComponent },
  { path: ':merchant/:race_name/:team_id/:runner_id', component: RunnerComponent },
  { path: ':merchant/:race_name/privacy', component: PrivacyComponent },
  { path: ':merchant/:race_name/terms', component: TermsConditionsComponent },
];

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    FooterComponent,
    HomeComponent,
    DonorComponent,
    RunnerComponent,
    ContactComponent,
    ParticipantsComponent,
    LogInComponent,
    JoinUpComponent,
    NoMerchantComponent,
    AllRacesComponent,
    PrivacyComponent,
    TermsConditionsComponent,
    DynamicPagesComponent,
    LoaderComponent,
    FindParticipantsPipe,
    WithoutDecimalsPipe,
    LoginModalComponent,
    CollectorUpdateComponent,
    StatusPageComponent,
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(appRoutes),
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    RecaptchaModule.forRoot()
  ],
  providers: [LoginService],
  bootstrap: [AppComponent]
})
export class AppModule { }
